/**
 * Formatting utilities for display values.
 */

/** HTML-escapes untrusted text to prevent XSS */
export function escapeHTML(value: unknown): string {
  if (value === null || value === undefined) return '';
  return String(value)
    .replace(/&/g, '&')
    .replace(/</g, '<')
    .replace(/>/g, '>')
    .replace(/"/g, '"')
    .replace(/'/g, '&#39;');
}

/** Formats a Firestore timestamp or Date to a relative string */
export function timeAgo(date: Date | null | undefined): string {
  if (!date) return '';
  const seconds = Math.floor((Date.now() - date.getTime()) / 1000);
  if (seconds < 60) return 'just now';
  if (seconds < 3600) return `${Math.floor(seconds / 60)}m ago`;
  if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ago`;
  if (seconds < 604800) return `${Math.floor(seconds / 86400)}d ago`;
  return date.toLocaleDateString('en-NG');
}

/** Formats a number with Nigerian Naira */
export function formatNaira(amount: number): string {
  return `₦${amount.toLocaleString('en-NG')}`;
}

/** Validates a WhatsApp number (10-15 digits) */
export function isValidWhatsAppNumber(number: unknown): boolean {
  return typeof number === 'string' && /^\d{10,15}$/.test(number);
}

/** Truncates text with ellipsis */
export function truncate(text: string, maxLength: number = 120): string {
  if (text.length <= maxLength) return text;
  return text.slice(0, maxLength).trim() + '…';
}